import request from '@/api/request.js'; //请求对象
import store from '@/store/index.js';
import axios from 'axios';
var instance = axios.create({
    timeout: (1000 * 60 * 20),
	baseURL:'/apis',
    // baseURL:base.getServerInfo().api_server
	headers: { 'content-type': 'multipart/form-data' }
});

// 2026-10-06：每次发送音效保存请求前读取最新登录令牌。
// 例如管理员在当前页面完成登录后，Vuex 中的 token 已经更新；如果只在本文件加载时
// 读取一次，后续添加或修改音效仍会携带登录前的空 token，服务端就会误判为登录异常。
instance.interceptors.request.use(config => {
	const token = store.getters.getToken
	if (token) {
		config.headers['x-token'] = token
	}
	return config
})

 const apis = {
	
	create (params, config=null){
		return instance.post(`/admin_sounds/create`,params,config)
		// return request({url: `/admin_sounds/create`, method: 'POST', data:params})
	},
	update (params,config=null){
		return instance.post(`/admin_sounds/update`,params,config)
		// return request({url: `/admin_sounds/update`, method: 'POST', data:params})
	},
	setSoundsDiscription (params){
		return request({url: `/admin_sounds/setSoundsDiscription`, method: 'POST', data:params})
	},
	remove (params){
		return request({url: `/admin_sounds/remove`, method: 'POST', data:params})
	},
	read (params){
		return request({url: `/admin_sounds/read`,params:params, method: 'GET'})
	},
	readOneSound (params){
		return request({url: `/admin_sounds/ReadOneSound`,params:params, method: 'GET'})
	},
 }
 
 export default apis;
